/**
 * ============================================================
 * STATIONS MAP
 * ============================================================
 */

const stationsMaps = document.querySelectorAll("[data-stations-map]");

stationsMaps.forEach((stationsMap) => {
    /**
     * --------------------------------------------------------
     * ÉLÉMENTS
     * --------------------------------------------------------
     */

    const markers = stationsMap.querySelectorAll("[data-station-marker]");

    const panel = stationsMap.querySelector("[data-station-panel]");

    const closeButton = stationsMap.querySelector("[data-station-close]");

    const searchInput = stationsMap.querySelector("[data-station-search]");

    const fuelFilter = stationsMap.querySelector("[data-station-filter]");

    const dataElement = stationsMap.querySelector("[data-stations-data]");

    /**
     * --------------------------------------------------------
     * VÉRIFICATION
     * --------------------------------------------------------
     */

    if (!dataElement || !panel) {
        return;
    }

    /**
     * --------------------------------------------------------
     * DONNÉES
     * --------------------------------------------------------
     */

    let data = {
        stations: {},
        markers: [],
        payment_methods: {},
    };

    try {
        data = JSON.parse(dataElement.textContent);
    } catch (error) {
        console.error("Altens — Erreur données stations.", error);

        return;
    }

    const stations = data.stations || {};

    const mapMarkers = Array.isArray(data.markers) ? data.markers : [];

    const paymentMethods = data.payment_methods || {};

    /**
     * --------------------------------------------------------
     * ÉLÉMENTS DE LA FICHE
     * --------------------------------------------------------
     */

    const imageContainer = panel.querySelector("[data-station-image-container]");

    const image = panel.querySelector("[data-station-image]");

    const name = panel.querySelector("[data-station-name-output]");

    const hours = panel.querySelector("[data-station-hours]");

    const addressContainer = panel.querySelector("[data-station-address-container]");

    const address = panel.querySelector("[data-station-address]");

    const coordinates = panel.querySelector("[data-station-coordinates]");

    const accessibilityContainer = panel.querySelector("[data-station-accessibility-container]");

    const accessibility = panel.querySelector("[data-station-accessibility]");

    const fuelsContainer = panel.querySelector("[data-station-fuels-container]");

    const fuels = panel.querySelector("[data-station-fuels-output]");

    const paymentsContainer = panel.querySelector("[data-station-payments-container]");

    const payments = panel.querySelector("[data-station-payments]");

    /**
     * --------------------------------------------------------
     * NORMALISATION DU TEXTE
     * --------------------------------------------------------
     *
     * La recherche ignore :
     *
     * - les majuscules ;
     * - les accents ;
     * - les espaces multiples ;
     * - les apostrophes typographiques ;
     * - une partie de la ponctuation.
     *
     * Exemples :
     *
     * Île-de-France
     * ile de france
     * ILE-DE-FRANCE
     *
     * sont considérés de manière équivalente.
     */

    const normalizeText = (value = "") => {
        return value
            .toString()
            .normalize("NFD")
            .replace(/[\u0300-\u036f]/g, "")
            .replace(/[’']/g, " ")
            .replace(/[-_/]/g, " ")
            .replace(/[.,;:()[\]{}]/g, " ")
            .replace(/\s+/g, " ")
            .toLowerCase()
            .trim();
    };

    /**
     * --------------------------------------------------------
     * INDEX DES MARQUEURS
     * --------------------------------------------------------
     *
     * Permet de retrouver rapidement les données JSON
     * correspondant à un bouton de la carte.
     */

    const mapMarkersById = new Map();

    mapMarkers.forEach((marker) => {
        if (!marker || !marker.id) {
            return;
        }

        mapMarkersById.set(String(marker.id), marker);
    });

    /**
     * --------------------------------------------------------
     * INDEX DE RECHERCHE
     * --------------------------------------------------------
     *
     * Fonction commune aux stations et aux projets.
     *
     * Elle utilise :
     *
     * - nom ;
     * - adresse ;
     * - ville ;
     * - commune ;
     * - département ;
     * - code département ;
     * - région ;
     * - termes de recherche personnalisés.
     */

    const getSearchIndex = (item = {}) => {
        const searchTerms = Array.isArray(item.search_terms) ? item.search_terms : [];

        const values = [item.name, item.address, item.city, item.commune, item.department, item.department_name, item.department_code, item.region, ...searchTerms];

        return normalizeText(values.filter(Boolean).join(" "));
    };

    /**
     * --------------------------------------------------------
     * CORRESPONDANCE RECHERCHE
     * --------------------------------------------------------
     *
     * Chaque mot saisi doit être présent dans l'index.
     *
     * Exemple :
     *
     * "grand est"
     *
     * recherche "grand" ET "est".
     *
     * Cela rend la recherche plus tolérante aux tirets
     * et à la ponctuation.
     */

    const matchesSearchQuery = (item, searchValue) => {
        if (!searchValue) {
            return true;
        }

        const searchIndex = getSearchIndex(item);

        if (!searchIndex) {
            return false;
        }

        const searchWords = searchValue.split(" ").filter(Boolean);

        return searchWords.every((word) => searchIndex.includes(word));
    };

    /**
     * --------------------------------------------------------
     * FERMER LA FICHE
     * --------------------------------------------------------
     */

    const closeStation = () => {
        panel.classList.add("hidden");

        panel.setAttribute("aria-hidden", "true");

        markers.forEach((marker) => {
            marker.classList.remove("is-active");
        });

        stationsMap.classList.remove("has-active-station");
    };

    /**
     * --------------------------------------------------------
     * IMAGE
     * --------------------------------------------------------
     */

    const updateStationImage = (station) => {
        if (!image || !imageContainer) {
            return;
        }

        if (station.image) {
            image.src = station.image;

            image.alt = station.image_alt || station.name || "";

            imageContainer.classList.remove("hidden");

            return;
        }

        image.removeAttribute("src");

        image.alt = "";

        imageContainer.classList.add("hidden");
    };

    /**
     * --------------------------------------------------------
     * HORAIRES
     * --------------------------------------------------------
     */

    const updateStationHours = (station) => {
        if (!hours) {
            return;
        }

        const value = station.opening_hours || "";

        hours.textContent = value;

        hours.classList.toggle("hidden", !value);
    };

    /**
     * --------------------------------------------------------
     * ADRESSE / COORDONNÉES
     * --------------------------------------------------------
     */

    const updateStationLocation = (station) => {
        const hasAddress = Boolean(station.address);

        const hasCoordinates = station.coordinates && station.coordinates.lat !== undefined && station.coordinates.lng !== undefined;

        /**
         * Adresse.
         */

        if (address) {
            address.textContent = station.address || "";
        }

        /**
         * Coordonnées GPS.
         */

        if (coordinates) {
            if (hasCoordinates) {
                coordinates.textContent = `Coordonnées GPS : ${station.coordinates.lat}, ${station.coordinates.lng}`;
            } else {
                coordinates.textContent = "";
            }
        }

        /**
         * Conteneur.
         */

        if (addressContainer) {
            addressContainer.classList.toggle("hidden", !hasAddress && !hasCoordinates);
        }
    };

    /**
     * --------------------------------------------------------
     * ACCESSIBILITÉ
     * --------------------------------------------------------
     */

    const updateStationAccessibility = (station) => {
        const stationAccessibility = Array.isArray(station.accessibility) ? station.accessibility : [];

        if (accessibility) {
            accessibility.textContent = stationAccessibility.join(", ");
        }

        if (accessibilityContainer) {
            accessibilityContainer.classList.toggle("hidden", stationAccessibility.length === 0);
        }
    };

    /**
     * --------------------------------------------------------
     * CARBURANTS
     * --------------------------------------------------------
     */

    const updateStationFuels = (station) => {
        const stationFuels = Array.isArray(station.fuels) ? station.fuels : [];

        if (fuels) {
            fuels.textContent = stationFuels.join(", ");
        }

        if (fuelsContainer) {
            fuelsContainer.classList.toggle("hidden", stationFuels.length === 0);
        }
    };

    /**
     * --------------------------------------------------------
     * MOYENS DE PAIEMENT
     * --------------------------------------------------------
     */

    const updateStationPayments = (station) => {
        if (!payments) {
            return;
        }

        payments.innerHTML = "";

        const stationPayments = Array.isArray(station.payment_methods) ? station.payment_methods : [];

        stationPayments.forEach((paymentId) => {
            const payment = paymentMethods[paymentId];

            if (!payment || !payment.icon) {
                return;
            }

            const paymentImage = document.createElement("img");

            paymentImage.src = payment.icon;

            paymentImage.alt = payment.label || "";

            paymentImage.loading = "lazy";

            paymentImage.className = "h-[30px] w-auto object-contain";

            payments.appendChild(paymentImage);
        });

        if (paymentsContainer) {
            paymentsContainer.classList.toggle("hidden", stationPayments.length === 0);
        }
    };

    /**
     * --------------------------------------------------------
     * OUVERTURE D'UNE STATION
     * --------------------------------------------------------
     */

    const openStation = (marker) => {
        const stationId = marker.dataset.stationId;

        if (!stationId) {
            return;
        }

        const station = stations[stationId];

        if (!station) {
            return;
        }

        /**
         * Désactive les autres marqueurs.
         */

        markers.forEach((item) => {
            item.classList.remove("is-active");
        });

        /**
         * Active le marqueur.
         */

        marker.classList.add("is-active");

        stationsMap.classList.add("has-active-station");

        /**
         * Nom.
         */

        if (name) {
            name.textContent = station.name || "";
        }

        /**
         * Contenu.
         */

        updateStationImage(station);

        updateStationHours(station);

        updateStationLocation(station);

        updateStationAccessibility(station);

        updateStationFuels(station);

        updateStationPayments(station);

        /**
         * Affiche la fiche.
         */

        panel.classList.remove("hidden");

        panel.setAttribute("aria-hidden", "false");
    };

    /**
     * --------------------------------------------------------
     * CLIC SUR LES MARQUEURS
     * --------------------------------------------------------
     *
     * Les projets restent uniquement informatifs.
     *
     * Ils peuvent être recherchés et filtrés visuellement,
     * mais seuls les marqueurs possédant un station_id
     * ouvrent la fiche station.
     */

    markers.forEach((marker) => {
        marker.addEventListener("click", () => {
            if (!marker.dataset.stationId) {
                return;
            }

            openStation(marker);
        });
    });

    /**
     * --------------------------------------------------------
     * FERMETURE
     * --------------------------------------------------------
     */

    closeButton?.addEventListener("click", () => {
        closeStation();
    });

    /**
     * --------------------------------------------------------
     * TOUCHE ESCAPE
     * --------------------------------------------------------
     */

    document.addEventListener("keydown", (event) => {
        if (event.key !== "Escape") {
            return;
        }

        if (!stationsMap.classList.contains("has-active-station")) {
            return;
        }

        closeStation();
    });

    /**
     * --------------------------------------------------------
     * RÉCUPÉRER LES DONNÉES D'UN MARQUEUR
     * --------------------------------------------------------
     *
     * Station :
     * on utilise les données complètes de la station.
     *
     * Projet :
     * on utilise directement les données du marker JSON.
     */

    const getMarkerSearchData = (marker) => {
        const stationId = marker.dataset.stationId;

        if (stationId && stations[stationId]) {
            return stations[stationId];
        }

        const markerId = marker.dataset.markerId;

        if (!markerId) {
            return null;
        }

        return mapMarkersById.get(markerId) || null;
    };

    /**
     * --------------------------------------------------------
     * FILTRAGE
     * --------------------------------------------------------
     */

    const filterMarkers = () => {
        const searchValue = normalizeText(searchInput?.value || "");

        const selectedFuel = normalizeText(fuelFilter?.value || "");

        let activeMarkerStillVisible = false;

        markers.forEach((marker) => {
            const stationId = marker.dataset.stationId;

            const markerData = getMarkerSearchData(marker);

            /**
             * --------------------------------------------
             * DONNÉES INTROUVABLES
             * --------------------------------------------
             */

            if (!markerData) {
                const shouldDisplay = !searchValue && !selectedFuel;

                marker.classList.toggle("hidden", !shouldDisplay);

                marker.setAttribute("aria-hidden", shouldDisplay ? "false" : "true");

                return;
            }

            /**
             * --------------------------------------------
             * RECHERCHE GÉOGRAPHIQUE
             * --------------------------------------------
             *
             * Fonctionne pour :
             *
             * - stations ;
             * - BESS ;
             * - photovoltaïque ;
             * - ombrières.
             */

            const matchesSearch = matchesSearchQuery(markerData, searchValue);

            /**
             * --------------------------------------------
             * FILTRE CARBURANT
             * --------------------------------------------
             *
             * Le filtre carburant ne concerne que
             * les stations.
             *
             * Lorsqu'un carburant est sélectionné,
             * les projets énergétiques sont masqués.
             */

            let matchesFuel = true;

            if (selectedFuel) {
                if (!stationId) {
                    matchesFuel = false;
                } else {
                    const stationFuels = Array.isArray(markerData.fuels) ? markerData.fuels.map((fuel) => normalizeText(fuel)) : [];

                    matchesFuel = stationFuels.includes(selectedFuel);
                }
            }

            /**
             * --------------------------------------------
             * VISIBILITÉ
             * --------------------------------------------
             */

            const isVisible = matchesSearch && matchesFuel;

            marker.classList.toggle("hidden", !isVisible);

            marker.setAttribute("aria-hidden", isVisible ? "false" : "true");

            /**
             * Vérifie si la station active
             * reste visible.
             */

            if (isVisible && marker.classList.contains("is-active")) {
                activeMarkerStillVisible = true;
            }
        });

        /**
         * ----------------------------------------------------
         * FERMETURE SI LA STATION ACTIVE EST FILTRÉE
         * ----------------------------------------------------
         */

        if (stationsMap.classList.contains("has-active-station") && !activeMarkerStillVisible) {
            closeStation();
        }
    };

    /**
     * --------------------------------------------------------
     * RECHERCHE
     * --------------------------------------------------------
     */

    searchInput?.addEventListener("input", filterMarkers);

    /**
     * --------------------------------------------------------
     * FILTRE CARBURANT
     * --------------------------------------------------------
     */

    fuelFilter?.addEventListener("change", filterMarkers);

    /**
     * --------------------------------------------------------
     * INITIALISATION
     * --------------------------------------------------------
     */

    closeStation();

    filterMarkers();
});
